export const STRAPI_DEVELOPMENT = "http://localhost:1337";
export const STRAPI_PRODUCTION = "https://zombie-app-backend.herokuapp.com";
